import { Component, OnInit } from '@angular/core';
import { AppService } from './services/app.services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  authInfo = {};
  title = 'Capture Q';

  constructor(private appServ: AppService) {}

  ngOnInit() {
    
  }

}
